<template>
  <div>
    <div>
      <v-btn
        v-if="!previewHidden"
        class="float-right"
        @click="showModal"
      >
        Vorschau Tenants
      </v-btn>
    </div>
    <v-dialog
      v-model="showDialog"
    >
      <v-card class="p-5">
        <u-loader
          v-if="isLoading"
        />
        <div v-else>
          <v-btn
            class="float-right"
            @click="hideModal"
          >
            Schliessen
          </v-btn>
          <div class="row mb-4">
            <v-autocomplete
              key="tenantDropdown"
              v-model="selectedTenants"
              :items="tenantOptions"
              chips
              label="Tenants"
              item-value="tenant"
              multiple
              class="col-4"
            />
            <v-select
              key="languageDropdown"
              v-model="selectedLanguages"
              :items="languageOptions"
              chips
              label="Sprachen"
              item-value="language"
              multiple
              class="col-3"
            />
          </div>
          <div
            v-for="(tenant, tenantIndex) in selectedTenants"
            :key="tenantIndex"
            class="mb-3"
          >
            <h5>{{ tenantOptions.find(x => x.tenant == tenant).text }}</h5>
            <div
              class="row"
            >
              <v-card
                v-for="(lang, langIndex) in selectedLanguages"
                :key="langIndex"
                :class="colsPerLanguage"
              >
                <strong>{{ languageOptions.find(x => x.language == lang).text }}</strong>
                <span
                  v-safe-html="getPreviewOfTenant(tenant, lang)"
                />
              </v-card>
            </div>
          </div>  
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { GetCriterionPreview } from '@/services/contract.edition.criterion.service';

export default {
  props: {
    contractId: {
      type: String,
      default: "",
    },
    versionId: {
      type: Number,
      default: 0,
    },
    editionId: {
      type: Number,
      default: 0,
    },
    klausel: {
      type: Object,
      required: true
    },
    languages: {
      type: Array,
      default: () => []
    },
    activeLanguage: {
      type: String,
      default: () => 'all'
    }
  },
  data(){
    return {
      showDialog: false,
      isLoading: false,
      tenants: [],
      previews: [],
      selectedTenants: [],
      selectedLanguages: [],
      allTenantOptions: [
        { tenant: 2, text: "Tenant TempData" },
        { tenant: 3, text: "Tenant Seco" },
        { tenant: 4, text: "Tenant Unia.ch (smartcom)" },
        { tenant: 7, text: "Tenant Workcontrol" }
      ],
      allLanguageOptions: [
        { language: "de-CH", text: "DE" },
        { language: "fr-CH", text: "FR" },
        { language: "it-CH", text: "IT" }
      ]
    }
  },
  computed: {
    tenantOptions() {
      return this.allTenantOptions.filter(x => this.tenants.some(y => y === x.tenant));
    },
    languageOptions() {
      return this.allLanguageOptions.filter(x => this.languages.some(y => y === x.language));
    },
    colsPerLanguage() {
      switch(this.selectedLanguages.length){
        case 3:
          return "col-4"
        case 2:
          return "col-6"
        default:
          return "col-12"
      }
    },
    previewHidden(){
      if(this.tenants.length === 0){
        return true;
      }
      if(!this.klausel.Data.klauselContents.some(x => x.value)){
        return true;
      }

      return false;
    }
  },
  watch: {
    activeLanguage(){
      if(this.activeLanguage === "all"){
        this.selectedLanguages = this.allLanguageOptions.map(x => x.language);
      } else {
        this.selectedLanguages = [this.activeLanguage]
      }
    }
  },  
  created(){
    if(this.klausel.isTenantTempData){
      this.tenants.push(2);
    }
    if(this.klausel.isTenantSeco){
      this.tenants.push(3);
    }
    if(this.klausel.isTenantUnia){
      this.tenants.push(4);
    }
    if(this.klausel.isTenantWorkcontrol){
      this.tenants.push(7);
    }

    this.selectedTenants = this.tenants;

    if(this.activeLanguage === "all"){
      this.selectedLanguages = this.allLanguageOptions.map(x => x.language);
    } else {
      this.selectedLanguages = [this.activeLanguage]
    }
  },
  methods: {
    getPreviewOfTenant(tenant, language){
      const previewContent = this.previews.find(x => x.tenant == tenant)?.contents.find(x => x.language == language)?.value;
      if(!previewContent){
        return "<div><strong>Diese Klausel wird in dieser Sprache nicht ausgegeben</strong></div>";
      }
      return previewContent;
    },
    showModal(){
      this.isLoading = true;
      this.showDialog = true;

      GetCriterionPreview(
        this.contractId,
        this.versionId,
        this.editionId,
        this.klausel.klauselTypeId,
        {
          isAve: this.klausel.isAve,
          tenants: this.tenants,
          contents: this.klausel.Data.klauselContents
        },
        (response) => {
          this.previews = response;
          this.isLoading = false
        },
        (error) => {
          console.error(error)
        }
      )
    },
    hideModal(){
      this.showDialog = false;
    }
  }
}
</script>
<style>
  .smartcom {
    background-color: #FFFFFF;
    padding: 0px;
    border-radius: 0px;
  }

  .nonave {
    background-color: #FFFFFF;
    padding: 0px;
    border-radius: 0px;
  }

  .nonpvl {
    background-color: #FFFFFF;
    padding: 0px;
    border-radius: 0px;
  }
</style>